"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SvgLink = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Svg = _interopRequireDefault(require("./Svg"));

var SvgLink = function SvgLink(_ref) {
  var size = _ref.size,
      title = _ref.title,
      desc = _ref.desc,
      titleId = _ref.titleId,
      descId = _ref.descId,
      props = (0, _objectWithoutProperties2["default"])(_ref, ["size", "title", "desc", "titleId", "descId"]);
  return _react["default"].createElement(_Svg["default"], (0, _extends2["default"])({
    viewBox: "0 0 24 24",
    height: size,
    width: size,
    fill: "currentcolor"
  }, props), !!title && _react["default"].createElement("title", {
    id: titleId
  }, title), !!desc && _react["default"].createElement("desc", {
    id: descId
  }, desc), _react["default"].createElement("g", {
    className: "link_svg__nc-icon-wrapper"
  }, _react["default"].createElement("path", {
    d: "M14.242 9.758a6.01 6.01 0 00-1.659-1.169A1.99 1.99 0 0012 10c0 .213.04.415.102.608.259.161.505.343.726.564C13.583 11.928 14 12.932 14 14s-.416 2.073-1.171 2.829l-3 2.999c-1.512 1.512-4.146 1.512-5.657 0C3.416 19.072 3 18.068 3 17s.416-2.072 1.171-2.828l2.104-2.104A8.05 8.05 0 016 10c0-.162.013-.323.023-.483-.089.079-.18.156-.266.241l-3 3C1.624 13.891 1 15.397 1 17s.624 3.109 1.757 4.242C3.891 22.376 5.397 23 7 23s3.109-.624 4.243-1.758l3-2.999C15.375 17.109 16 15.603 16 14s-.625-3.109-1.758-4.242z"
  }), _react["default"].createElement("path", {
    "data-color": "color-2",
    d: "M21.243 2.758C20.109 1.624 18.603 1 17 1s-3.109.624-4.243 1.758l-3 2.999C8.625 6.891 8 8.397 8 10s.624 3.109 1.757 4.242a6.01 6.01 0 001.659 1.169c.376-.377.584-.879.584-1.411 0-.218-.041-.425-.106-.622a3.7 3.7 0 01-.721-.55C10.417 12.072 10 11.068 10 10s.416-2.073 1.171-2.829l3-2.999C14.927 3.416 15.932 3 17 3s2.073.416 2.829 1.172C20.584 4.928 21 5.932 21 7s-.416 2.072-1.171 2.828l-2.107 2.107C17.9 12.601 18 13.292 18 14c0 .162-.012.322-.021.482.089-.079.18-.155.265-.24l3-3C22.376 10.109 23 8.603 23 7s-.624-3.109-1.757-4.242z"
  })));
};

exports.SvgLink = SvgLink;
SvgLink.isIcon = true;
SvgLink.defaultProps = {
  size: 24,
  'aria-hidden': 'true',
  focusable: 'false'
};
var _default = SvgLink;
exports["default"] = _default;